import React from "react";
import { ACTIONS } from "@cadenza/i18n-core";
import { useLanguageContext } from "@cadenza/i18n-react";
import { useHistoryContext } from "./HistoryContext.jsx";
import { CSButton, ButtonGroup } from "@cadenza/ui";
import {
  FaUndo,
  FaRedo,
  FaFastBackward,
  FaFastForward,
  FaEraser,
} from "react-icons/fa";

const UndoRedoController = () => {
  const {
    undo,
    redo,
    canUndo,
    canRedo,
    undoCount = 0,
    redoCount = 0,
    undoAll,
    redoAll,
    // optional clearHistory if your app exposes it via context in future
    clearHistory,
  } = useHistoryContext();

  const { STRINGS = {} } = useLanguageContext() || {};
  const UNDO = STRINGS[ACTIONS.UNDO] || "Undo";
  const REDO = STRINGS[ACTIONS.REDO] || "Redo";
  const UNDO_ALL = STRINGS[ACTIONS.UNDO_ALL] || "Undo all changes";
  const REDO_ALL = STRINGS[ACTIONS.REDO_ALL] || "Redo all changes";
  const CLEAR_HISTORY =
    STRINGS[ACTIONS.CLEAR_HISTORY] || "Clear change history";

  return (
    <ButtonGroup align="between" framed>
      <CSButton
        onClick={undoAll}
        disabled={!canUndo}
        title={UNDO_ALL}
        aria-label={UNDO_ALL}
      >
        <div className="icon-wrapper">
          <FaFastBackward className="cs-icon" title={UNDO_ALL} />
          {undoCount > 0 && <span className="badge">{undoCount}</span>}
        </div>
      </CSButton>
      <CSButton
        onClick={undo}
        disabled={!canUndo}
        title={UNDO}
        aria-label={UNDO}
      >
        <div className="icon-wrapper">
          <FaUndo className="cs-icon" title={UNDO} />
        </div>
      </CSButton>
      <CSButton
        onClick={redo}
        disabled={!canRedo}
        title={REDO}
        aria-label={REDO}
      >
        <div className="icon-wrapper">
          <FaRedo className="cs-icon" title={REDO} />
        </div>
      </CSButton>
      <CSButton
        onClick={redoAll}
        disabled={!canRedo}
        title={REDO_ALL}
        aria-label={REDO_ALL}
      >
        <div className="icon-wrapper">
          <FaFastForward className="cs-icon" title={REDO_ALL} />
          {redoCount > 0 && <span className="badge">{redoCount}</span>}
        </div>
      </CSButton>
      {typeof clearHistory === "function" && (
        <CSButton
          onClick={clearHistory}
          disabled={!canUndo && !canRedo}
          title={CLEAR_HISTORY}
          aria-label={CLEAR_HISTORY}
        >
          <FaEraser className="cs-icon" />
        </CSButton>
      )}
    </ButtonGroup>
  );
};

export default UndoRedoController;
